module.exports = __webpack_public_path__ + "static/marketing_expert-08035637570277c9200f7a430bcf68dc.png";